import { useEffect, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { KeyUri } from "../key";
import { trackEvent } from "../utils/metaPixel";

const HotelCashfreePaymentStatus = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    const verifyPayment = async () => {
      try {
        const orderId = searchParams.get("order_id");

        if (!orderId) {
          navigate("/", {
            replace: true,
            state: {
              toastType: "error",
              toastMessage: "Invalid payment response",
            },
          });
          return;
        }

        const bookingId = sessionStorage.getItem("cashfree_hotel_booking_id");

        const response = await axios.post(
          `${KeyUri.BACKEND_URI}/hotel-bookings/verify-cashfree-payment`,
          { orderId, bookingId }
        );

        if (response.data?.success) {
          const booking = response.data.booking;
          const confirmedBookingId = booking?._id;

          
          const eventId = sessionStorage.getItem("cashfree_hotel_event_id");
          const value = sessionStorage.getItem("cashfree_hotel_value") || booking?.amountPaid;
          const propertyId = sessionStorage.getItem("cashfree_hotel_property_id") || booking?.propertyId;

          trackEvent("Purchase", {
            value: Number(value || 0),
            currency: "INR",
            content_ids: [propertyId],
            content_type: "hotel_room",
            content_name: "Hotel Booking",
          }, eventId || booking?.eventId);

          sessionStorage.removeItem("cashfree_hotel_booking_id");
          sessionStorage.removeItem("cashfree_hotel_event_id");
          sessionStorage.removeItem("cashfree_hotel_value");
          sessionStorage.removeItem("cashfree_hotel_property_id");

          alert(`Booking confirmed! Your booking reference is ${booking?.bookingId || confirmedBookingId}`);

          navigate(`/hotel-invoice?bookingId=${confirmedBookingId}`);
        } else {
          alert(response.data?.message || "Payment failed or was not completed.");
          navigate("/");
        }
      } catch (error) {
        console.error(error);
        alert(error?.response?.data?.message || "Payment verification failed.");
        navigate("/");
      }
    };

    verifyPayment();
  }, []);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      backgroundColor: "#f8fafc"
    }}>
      <div style={{
        width: 48,
        height: 48,
        border: "4px solid #e5e7eb",
        borderTop: "4px solid #2563eb",
        borderRadius: "50%",
        animation: "spin 0.8s linear infinite"
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{ color: "#6b7280", fontSize: 16 }}>Confirming your booking...</p>
    </div>
  );
};

export default HotelCashfreePaymentStatus;